import * as Rx from 'rxjs';
import { map, tap } from 'rxjs/operators';

import type { IProductSales } from 'v2/interfaces/product';

import selectAffiliateService from '../affiliate/selectAffiliate';
import apiService from '../api';

import type { SelectAffiliateService } from '../affiliate/selectAffiliate';
import type { ApiService } from '../api';

export enum EType {
  SCROLL = 'scroll',
  PAGINATION = 'pagination',
}

export class SalesService {
  private affiliates$ = new Rx.BehaviorSubject<any[]>([]);
  private products$ = new Rx.BehaviorSubject<IProductSales[]>([]);
  private loadingProducts$ = new Rx.BehaviorSubject<boolean>(false);

  constructor(private readonly apiService: ApiService, private readonly selectAffiliateService: SelectAffiliateService) {}

  public getAffiliates = (): Rx.Observable<any[]> => this.affiliates$;

  public getProducts = (): Rx.Observable<IProductSales[]> => this.products$;

  isLoadingProducts = () => this.loadingProducts$;

  public setProducts = (products: any[]) => {
    this.products$.next(products);
  };

  public loadProducts() {
    this.apiService
      .get('reports/sales-filter-products')
      .pipe(
        tap(() => this.loadingProducts$.next(true)),
        map((response) => response.data),
        tap(() => this.loadingProducts$.next(false))
      )
      .subscribe((products: any) => this.products$.next(products));
  }

  public loadAffiliates() {
    this.apiService
      .get('reports/affiliates')
      .pipe(map((response) => response.data.map((a: any) => ({ label: a.name, value: a.id }))))
      .subscribe((affiliates: any) => this.affiliates$.next(affiliates));
  }
}

const salesService = new SalesService(apiService, selectAffiliateService);
export default salesService;
